// types
import { i18nEaiUsers } from 'models/i18n';
import { UserAccountStatus } from 'utils/constants';

// ==============================|| I18N SK USERS ||============================== //

const skEaiUsers: i18nEaiUsers = {
  createUserWizard: {
    title: 'Vytvorenie používateľa',
    step01: 'Informácie o používateľovi',
    save: 'Vytvoriť používateľa'
  },
  userList: {
    title: 'Zoznam používateľov',
    searchInput: 'Zadajte e-mail',
    createEntityButton: 'Vytvoriť používateľa',
    columns: {
      username: 'Používateľské meno/E-mail',
      firstname: 'Meno',
      lastname: 'Priezvisko',
      status: 'Stav'
    },
    userActions: {
      detail: 'Detail',
      enable: 'Odblokovať',
      disable: 'Zablokovať'
    }
  },
  userDetail: {
    userProfile: {
      title: 'Profil',
      basicInfo: 'Základné informácie',
      accountStateSwitch: 'Aktívny',
      accountState: {
        [UserAccountStatus.ENABLED]: 'Zneplatniť používateľa',
        [UserAccountStatus.DISABLED]: 'Obnoviť používateľa'
      },
      resetPassword: 'Reset hesla',
      deleteUser: 'Zmazať používateľa'
    },
    userAssignment: {
      title: 'Priradenie používateľa',
      columns: {
        subjectAccount: 'Účet subjektu',
        accountType: 'Typ účtu',
        memberAccountStatus: 'Stav účtu',
        roles: 'Role',
        actions: 'Akcie'
      },
      addMemberAccount: 'Pridať účet subjektu',
      rolesAssignment: {
        columns: {
          role: 'Rola',
          validFromDate: 'Pridané',
          actions: 'Akcie'
        },
        addRole: 'Pridať rolu'
      }
    }
  },
  input: {
    email: 'Používateľské meno/E-mail',
    firstName: 'Meno',
    lastName: 'Priezvisko',
    emsMemberAccountId: 'Zasociovaný účet subjektu',
    role: 'Používateľská rola',
    username: 'Používateľské meno/E-mail'
  },
  validation: {
    'email-required': 'Používateľské meno/E-mail je povinný',
    'email-matches': 'Používateľské meno/E-mail nie je platný',
    'email-exists': 'Používateľské meno/E-mail musí byť unikátny',
    'firstName-required': 'Meno je povinné',
    'lastName-required': 'Priezvisko je povinné',
    'emsMemberAccountId-required': 'Zasociovaný účet subjektu je povinný'
  }
};

export default skEaiUsers;
